import React, { useState, useEffect, useRef, useContext } from 'react';
import { addBusinessDays } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { FaEdit, FaTrash,FaPen, FaCalculator  } from 'react-icons/fa';
import { BsFillSendFill } from "react-icons/bs";
import { Layout, Header, Modal,  DescriptionModal, CalculatorModal} from '../../../../components';
import { handleApi, formatCurrency,  inputDate,formatMediumDate,formatTwoDecimal,deepEqual } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditOrder = () => {
    const location = useLocation();
    const { order } = location.state || {};

    const [originalOrder, setOriginalOrder] = useState({ ...order });// duplicate quotation
    const [quotation, setQuotation] = useState(() => {
      // Check if quote exists and has required data
      const initialTransactionLines = order?.transactionLines?.length > 0
        ? order.transactionLines.map((line) => ({
            // Only select the fields you want from the quote's transaction line
            id: line.id || null,  
            product_id: line.product_id || null,  
            product_name: line.name || '',  
            description: line.description || line.products.name || '',
            unit_price: line.unit_price || 0,   
            priceExclusive:line.unit_price || 0,  
            discount_percentage: line.discount_percentage || 0,      
            quantity: line.quantity || 1,      
            total: (line.unit_price || 0) * (line.quantity || 1),  // Calculate total as unit_price * quantity
            totalExclusive: (line.unit_price || 0) * (line.quantity || 1)  // Calculate total as unit_price * quantity
            
          
          }))
        : [{
            // Default empty transaction line
            id: null, 
            product_id: null, 
            product_name: '',  
            description: '', 
            unit_price: 0,    
            discount_percentage: 0,      
            quantity: 1,      
            total: 0          
          }];

          // Always add an additional empty line for the new transaction
  if (initialTransactionLines.length === 0 || initialTransactionLines[initialTransactionLines.length - 1].total > 0) {
    initialTransactionLines.push({
      id: null,
      product_id: null,
      product_name: '',
      description: '',
      unit_price: 0,
      discount_percentage: 0,
      quantity: 1,
      total: 0,
      totalExclusive: 0
    });
  }
        
        return {
          date: inputDate(order?.date) || new Date().toISOString().split('T')[0],
          id: order?.id || '',
          partner_id: order?.partner_id || '',
          state: order?.state || 'draft',
          transactionLines: initialTransactionLines,  // Initialize transaction lines
          

        };
      });

      const [orderSummary, setOrderSummary] = useState({
        totalPriceExclusive: order?.totalPriceExclusive      || 0,
        totalDiscountExclusive: order?.totalDiscountExclusive || 0,
        totalDiscountInclusive: order?.totalDiscountInclusive || 0,
        totalDiscountedPriceInclusive: order?.totalDiscountedPriceInclusive || 0,
        totalDiscountedPriceExclusive: order?.totalDiscountedPriceExclusive || 0,
        subTotalAfterDiscount:order?.totalDiscountedPriceExclusive || 0,
        totalTaxBeforeDiscount: order?.totalTaxBeforeDiscount || 0,
        totalTaxAfterDiscounted: order?.totalTaxAfterDiscounted || 0,
        totalPriceInclusive: order?.totalPriceInclusive  || 0
      });   
      console.log('order summary sir ',{orderSummary})    
    const [isLoading, setIsLoading] = useState(false);
    const [products, setProducts] = useState([]); // products
    const [formattedProduct, setFormattedProduct] = useState(null);
    const [productDescription, setProductDescription] = useState('');  // description to pass to descriptionModal
    const [productName, setProductName] = useState(null);
    const [newProductLine, setNewProductLine] = useState(false);
    const [editedLineIndex, setEditedLineIndex] = useState(null);
    const [customers, setCustomers] = useState([]); // customers
    const [selectedCustomer, setSelectedCustomer] = useState(null); // The customer object
    const [selectedCustomerDetails, setSelectedCustomerDetails] = useState(null); // Extract details
    const [selectedLineIndex, setSelectedLineIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);
    const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);


    const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);

 
    const navigate = useNavigate();
    const descriptionRefs = useRef([]);
    const quantityRefs = useRef([]);
    useEffect(() => {
      const fetchData = async () => {
        try {const products = await fetchProducts();
        } catch (error) {console.error('Error fetching data:', error);} 
      };
      fetchData();
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    useEffect(() => { // **Effect to update order summary dynamically when transactionLines change**
     calculateOrderSummary()
     
    }, [quotation.transactionLines]); // Dependency: Updates when transactionLines change


  

  const fetchProducts = async () => {
        const apiEndpoint = 'products';
        const apiMethod = 'GET';
        const cleanedData = {};
        const parameters = {};
    
        try {
          const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
          if (response.error) {
            console.error(`Error fetching products: ${response.errorMessage}`);
            return;
          }
          const { status, data } = response;
        
          if (status === 200) {
            setProducts(data);
            const formattedproducts = data.map(product => ({
              value: product.id,
              label: product.name,  // Display product name in dropdown
              unit_price: product.unit_price || 0,  // Include the unit price in the dropdown options   
              unit_of_measure:product?.prices?.buy_uom_name || '',
    
    
            }));
            
     
            setFormattedProduct(formattedproducts);
            // Add the fetched product details to each transaction line
            const updatedTransactionLines = quotation.transactionLines.map(line => {
              // Find the matching product by product_id
              const matchedProduct = data.find(product => product.id === line.product_id);
              if (matchedProduct) {
                return {
                  ...line,
                  taxType:  matchedProduct?.sell_tax_info?.name || '', // get tax type
                  taxRate: matchedProduct?.sell_tax_info?.percentage || 0, // get tax rate
                };
              }
              return line;
            });

            // Update the quotation state with the updated transaction lines
            setQuotation(prevState => ({
              ...prevState,
              transactionLines: updatedTransactionLines,
            }));
          } else {toast.error(`Error ${status}: ${response.statusText}`);}
        } catch (error) {
          toast.error(error.message || 'An unexpected error occurred.');
        }
      };
      
    const handleOpenCalculator = (index) => {
        setEditedLineIndex(index);
        setIsCalculatorOpen(true);
        setIsDescriptionModalOpen(false);
        setIsModalOpen(true); // Ensure the main modal is opened too 
    };
    
    const handleSaveCalculatedQuantity = (calculatedQuantity) => {
      const updatedTransactionLines = [...quotation.transactionLines];
      updatedTransactionLines[selectedLineIndex].quantity = calculatedQuantity;
      updatedTransactionLines[selectedLineIndex].total = (updatedTransactionLines[selectedLineIndex].unit_price * calculatedQuantity) * (1 - updatedTransactionLines[selectedLineIndex].discount_percentage / 100);
      setQuotation({ ...quotation, transactionLines: updatedTransactionLines });
      setIsModalOpen(false);
    };
    const handleEditDescription = (index) => {
      setProductDescription(quotation.transactionLines[index].description);
      setProductName(quotation.transactionLines[index].product_name);
      setEditedLineIndex(index);
      setIsDescriptionModalOpen(true);
      setIsCalculatorOpen(false); // Make sure CalculatorModal is closed
      setIsModalOpen(true); // Ensure the main modal is opened too
    };
  
    const handleSaveNewDescription = (newDescription) => {
      const updatedTransactionLines = [...quotation.transactionLines];
      updatedTransactionLines[editedLineIndex].description = newDescription;
      setQuotation({ ...quotation, transactionLines: updatedTransactionLines });
      setProductDescription(newDescription); // Update the product description in the parent
      setIsModalOpen(false);
    };

    // Function to recalculate order summary
    


   

  
    const handleQuotationChange = (event) => {
      const { name, value } = event.target;
      let updatedQuotation = { ...quotation };
      if (name === 'customer') {
        updatedQuotation.partner_id = value;
        const customerDetails = customers.find(customer => customer.id === value);
        setSelectedCustomer(value);
        setSelectedCustomerDetails(customerDetails);
      } else if (name === 'date') {
        const selectedDate = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);
  
        if (selectedDate > today) {
          toast.error('Quotation date cannot be later than today.');
          return;
        }
        updatedQuotation.date = value;
      }
      setQuotation(updatedQuotation);
    };
  
    const handleTransactionLineChange = (index, event) => {
      const updatedTransactionLines = [...quotation.transactionLines];
      const updatedLine = updatedTransactionLines[index];
      const { name, value } = event.target;
    
      // Handle description change
      if (name === 'description') {
        const { value, label, unit_price } = event.target;
        const selectedProduct = products.find(product => product.id === value);
    
        // Check if the product already exists in the transaction lines
        const existingProductIndex = updatedTransactionLines.findIndex(line => line.product_id === value);
        if (existingProductIndex !== -1) {
          // If product exists, focus on the quantity field of the existing product
          setSelectedLineIndex(existingProductIndex);
          if (quantityRefs.current[existingProductIndex]) {
            quantityRefs.current[existingProductIndex].focus();
          }
          // alert("Product already exists. Adjust the quantity.");
          return; // Do not proceed further, prevent adding a new line
        }
    
        // If product doesn't exist, proceed with adding the new product
        console.log('sescted product',selectedProduct)
        updatedLine.product_id = value;
        updatedLine.description = label;
        updatedLine.product_name = label;
        updatedLine.taxType=  selectedProduct?.sell_tax_info?.name || ''; // get tax type
        updatedLine.taxRate=  selectedProduct?.sell_tax_info?.percentage || 0; // get tax rate
     
        updatedLine.unit_price = unit_price || selectedProduct?.prices?.buy_price_new || 0;
      
        
        updatedLine.quantity = updatedLine.quantity || 1;
        updatedLine.total = updatedLine.unit_price * updatedLine.quantity;
        updatedLine.totalExclusive = updatedLine.priceExclusive * updatedLine.quantity;
    
        setSelectedLineIndex(index);
    
        if (quantityRefs.current[index]) {quantityRefs.current[index].focus();  }// Focus on the quantity input
       
      }
    
      // Allow updates only if description (product_id) is filled
      if (name === 'unit_price') {
        if (!updatedLine.product_id) {
          alert("Please select a product description before updating the price.");
          return; // Exit early, do not update the unit price
        }
    
        const price = parseFloat(value);
        updatedLine.unit_price = isNaN(price) ? 0 : price;
        updatedLine.total = updatedLine.unit_price * updatedLine.quantity;
      }
    
      if (name === 'quantity') {
        const quantity = parseFloat(value) || 0; // Ensure valid quantity
        updatedLine.quantity = quantity;
        updatedLine.total = updatedLine.unit_price * quantity;
      }
    
      // Handle discount percentage
      if (name === 'discount_percentage') {
        const discountPercentage = parseFloat(value) || 0;
        updatedLine.discount_percentage = discountPercentage;
        updatedLine.total = updatedLine.unit_price * updatedLine.quantity * (1 - discountPercentage / 100);
        updatedLine.discount = updatedLine.priceExclusive * updatedLine.quantity * ( discountPercentage / 100);
      }
    
      // Ensure an empty line is added if the total is greater than 0
      if (updatedLine.total > 0 && !quotation.transactionLines.some(line => line.total === 0)) {
        updatedTransactionLines.push({
          product_id: null,
          product_name: '',
          description: '',
          unit_price: 0,
          discount_percentage: 0,
          quantity: 1,
          total: 0,
          totalExclusive: 0,
        });
      }

      
        
     
      
      //console.log('subtotal sir',subtotal)

      // Total Discount: Sum of the discounts applied on each line
      //const totalDiscount = updatedTransactionLines.reduce((acc, line) => acc + (line.priceExclusive * line.quantity * (line.discount_percentage / 100)), 0);

      


    
      // Update the quotation state with the modified transaction lines
      setQuotation({ ...quotation, transactionLines: updatedTransactionLines });
      calculateOrderSummary()

    }; 
  


    
    const handleApiWithTimeout = async (url, data, userData, method, parameters, timeout = 5000) => { // Timeout helper for API calls
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeout);
  
      try {
        const response = await handleApi(url, data, userData, method, parameters, { signal: controller.signal });
        return response;
      } catch (error) {
        if (error.name === 'AbortError') {
          toast.error('Request timed out');
        } else {
          toast.error('Error: ' + error.message);
        }
        throw error;
      } finally {
        clearTimeout(timeoutId);
      }
    };
  
    const handleSubmit = async (e,c) => {
        if (e && e.preventDefault) {e.preventDefault();} // Prevent default only if e is present  
        // Clean up the transactionLines array
        let  cleanedTransactionLines = quotation.transactionLines
        .filter(line => line.product_id !== null && line.unit_price !== 0) // Remove products with product_id null or price 0
        .map(line => {
        // Destructure the fields you want to exclude
        const { product_name, total, id, ...cleanedLine } = line;
    
        // If id is null, do not include it in the cleanedLine
        if (id === null) {delete cleanedLine.id;}
    
        return cleanedLine;
      });

      const hasChanged=  deepEqual(cleanedTransactionLines,originalOrder?.transactionLines)
      
      // Update the quotation object with cleaned transaction lines
      const updatedQuotation = {
        ...quotation,
        state: hasChanged ? 'draft' : quotation.state // Update status to 'draft' only if there are changes, otherwise leave it unchanged
      };
    
  // Ensure cleanedTransactionLines only contains the required fields
cleanedTransactionLines = cleanedTransactionLines.map(line => {
  return {
      description: line.description,
      discount_percentage: line.discount_percentage,
      product_id: line.product_id,
      quantity: line.quantity,
      unit_price: line.unit_price
  };
});


// Create the cleanedQuotation object
const cleanedQuotation = {
  ...quotation,
  transactionLines: cleanedTransactionLines,
  state: hasChanged ? 'draft' : quotation.state   // Update status to 'draft' only if there are changes, otherwise leave it unchanged
};

const parameters = { id: quotation.id };
const apiMethod = 'PUT';
console.log({ cleanedQuotation });


        setIsLoading(true);
        try {
          const response = await handleApi('purchase/orders', cleanedQuotation, userData, apiMethod,parameters);
          if (response.status === 200) {toast.success('Order updated  successfully.');
          }else {toast.error('Error saving Order.', response.statusText);}
        } catch (error) {
          toast.error('Error saving Order: ' + error.message);
        } finally {
          setNewProductLine(false);
          setActionCount(actionCount + 1);
          setIsLoading(false);
        }
      };
    
      const calculateOrderSummary = async () => {
        // Filter out transaction lines with missing product_id or unit_price of 0
        const cleanedTransactionLines = quotation.transactionLines
          .filter(line => line.product_id && line.unit_price !== 0); 
      
        console.log('cleaned transaction Lines', cleanedTransactionLines);
      
        let totalPriceInclusive = 0.00;
        let totalPriceExclusive = 0.00;
        let totalDiscountInclusive = 0.00;
        let totalDiscountExclusive = 0.00;
        let totalTaxBeforeDiscount = 0.00;
        let totalTaxAfterDiscounted = 0.00;
        let totalDiscountedPriceInclusive = 0.00;
        let totalDiscountedPriceExclusive = 0.00;
      
        // Process each cleaned transaction line
        cleanedTransactionLines.forEach((transactionLine) => {
          const unitPrice = parseFloat(transactionLine.unit_price);
          const taxType = transactionLine.taxType; // Prevent errors if tax_types is undefined
          const taxPercentage = transactionLine.taxRate;
          const discountPercentage = transactionLine.discount_percentage ? transactionLine.discount_percentage : 0.00;
          const quantity = transactionLine.quantity;
      
          console.log('cleaned transaction line sir ',{ cleanedTransactionLines });
      
          // Calculate prices based on tax type and discount percentage
          const unitPriceInclusive = taxType === "vat_inclusive" ? unitPrice : unitPrice * (1 + taxPercentage / 100);
          const unitPriceExclusive = taxType === "vat_exclusive" ? unitPrice : unitPrice / (1 + taxPercentage / 100);
          const unitDiscountInclusive = unitPriceInclusive * (discountPercentage / 100);
          const unitDiscountExclusive = unitPriceExclusive * (discountPercentage / 100);
          const unitDiscountedPriceInclusive = unitPriceInclusive * (1 - discountPercentage / 100);
          const unitDiscountedPriceExclusive = unitPriceExclusive * (1 - discountPercentage / 100);
          const unitTaxBeforeDiscount = unitPriceExclusive * taxPercentage / 100;
          const unitTaxAfterDiscounted = unitDiscountedPriceExclusive * taxPercentage / 100;
      
          const linePriceInclusive = unitPriceInclusive * quantity;
          const linePriceExclusive = unitPriceExclusive * quantity;
          const lineDiscountInclusive = unitDiscountInclusive * quantity;
          const lineDiscountExclusive = unitDiscountExclusive * quantity;
          const lineTaxBeforeDiscount = unitTaxBeforeDiscount * quantity;
          const lineTaxAfterDiscounted = unitTaxAfterDiscounted * quantity;
          const lineDiscountedPriceInclusive = unitDiscountedPriceInclusive * quantity;
          const lineDiscountedPriceExclusive = unitDiscountedPriceExclusive * quantity;
      
          
      
          // Aggregate the totals
          totalPriceInclusive += linePriceInclusive;
          totalPriceExclusive += linePriceExclusive;
          totalDiscountInclusive += lineDiscountInclusive;
          totalDiscountExclusive += lineDiscountExclusive;
          totalTaxBeforeDiscount += lineTaxBeforeDiscount;
          totalTaxAfterDiscounted += lineTaxAfterDiscounted;
          totalDiscountedPriceInclusive += lineDiscountedPriceInclusive;
          totalDiscountedPriceExclusive += lineDiscountedPriceExclusive;
        });
      console.log({totalPriceExclusive})
 
    // Update the existing orderSummary object with the calculated totals
    orderSummary.totalPriceInclusive = totalPriceInclusive.toFixed(2);
    orderSummary.totalPriceExclusive = totalPriceExclusive.toFixed(2);
    orderSummary.totalDiscountInclusive = totalDiscountInclusive.toFixed(2);
    orderSummary.totalDiscountExclusive = totalDiscountExclusive.toFixed(2);
    orderSummary.totalTaxBeforeDiscount = totalTaxBeforeDiscount.toFixed(2);
    orderSummary.totalTaxAfterDiscounted = totalTaxAfterDiscounted.toFixed(2);
    orderSummary.totalDiscountedPriceInclusive = totalDiscountedPriceInclusive.toFixed(2);
    orderSummary.totalDiscountedPriceExclusive = totalDiscountedPriceExclusive.toFixed(2);
  };      
  const handleClose = () => { navigate(-1);   }; // Navigate back when closing the form

  return (
    <Layout>
      <div className="m-4 bg-black rounded-xl shadow-2xl p-2">
        <ToastContainer position="top-center" autoClose={2000} />
        <div className="text-center py-4 border-b">
          <div className="w-full flex justify-end">
            <button
              className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
              title="Close"
              onClick={handleClose}
            >
              <MdOutlineCancel size={24} color={currentColor}/>
            </button>
          </div>      
          <div className="mx-4 text-white">
            <Header category="Purchase" title="Edit Payment" color={currentColor}/>
          </div>
        </div>        

        {/* Loading State */}
        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <Audio height="80" width="80" color="white" ariaLabel="loading" />
            <p className="mt-4 text-white">Processing order...</p>
          </div>
        ) : (
          <div className="bg-white p-6 my-4 rounded-xl shadow-2xl">
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              
              {/* Supplier Information */}
              <div className="p-4 bg-gray-50 shadow-md rounded-lg">
                <p className="text-lg text-center font-bold mb-2 uppercase">Supplier Info</p>
                <div className="space-y-1">
                <div className="flex justify-between text-sm">
                    <label className="font-medium">Supplier Name:</label>
                    <span>{order?.partners?.name || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                    <label className="font-medium">Contact Person:</label>
                    <span>{order?.partners?.contact_person || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                    <label className="font-medium">Phone:</label>
                    <span className='font-bold'>{order?.partners?.phone_number || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                    <label className="font-medium">Email:</label>
                    <span>{order?.partners?.email || 'N/A'}</span>
                    </div>
                </div>
              </div>

              {/* Payment Details */}
              <div className="p-4 bg-gray-50 shadow-md rounded-lg">
                <h3 className="text-lg font-bold text-gray-700 mb-3 uppercase text-center">Order info</h3>
                <div className="space-y-2 text-sm">
                    <div className="flex justify-between text-sm">
                        <label className="font-medium">Order No.:</label>
                        <span className='font-bold'>{order?.reference || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                        <label className="font-medium">Date:</label>
                        <span>{formatMediumDate(order?.date)}</span>
                    </div>
                                      
                    <div className="flex justify-between text-sm">
                        <label className="font-medium">Order Status:</label>
                        <span
                            className={`uppercase font-bold ml-2 ${
                                order?.state === 'draft'
                                ? 'text-yellow-700'
                                : order?.state === 'approved'
                                ? 'text-blue-600'
                                : order?.state === 'cancelled'
                                ? 'text-red-600'
                                : order?.state === 'deleted'
                                ? 'text-gray-400'
                                : order?.state === 'paid'
                                ? 'text-green-600'
                                : 'text-yellow-500' // Default to yellow for 'Pending' or unassigned states
                            }`}
                        >
                            {order?.state || 'Pending'}
                        </span>
                    </div>
                </div>
              </div>
            </div>

            <div className=' my-4 p-4 bg-gray-50 rounded-lg  hover:shadow-lg transition-all duration-300'> 
                <p className="text-lg text-center font-bold mb-2 uppercase">order detail</p>
                    {/* Render Table Header only if order exist */}
                    <div className="grid grid-cols-6 text-sm gap-4 p-2 border-b rounded-lg w-fulltext-gray-800 font-semibold">
                        <div className="col-span-2 text-left text-sm">Product Description</div>
                        <div className="col-span-1 text-center">Price</div>
                        <div className="col-span-1 text-center">Quantity</div>
                        <div className="col-span-1 text-center">Discount %</div>
                        <div className="col-span-1 text-right">Total</div>
                    </div>
                    {/* Render Payment Records */}
                    {quotation.transactionLines.length ? (
                      quotation.transactionLines.map((line, index) => (
                        <div key={index} className="grid grid-cols-6 px-3  bg-white border-b-gray hover:bg-gray-100 text-sm">
                          {/* date */}
                          <div className="col-span-2 relative">
                            <Select
                              key={index}
                              ref={(el) => (descriptionRefs.current[index] = el)}
                              name="description"
                              options={formattedProduct}
                              value={line.product_id ? { value: line.product_id, label: line.description } : null}
                              onChange={(selectedOption) => {
                              // Pass both value and label to handleTransactionLineChange
                                  handleTransactionLineChange(index, { target: { name: 'description', value: selectedOption.value, label: selectedOption.label } });
                              }} placeholder="Select Product"
                              className="react-select-container"
                              classNamePrefix="react-select"
                            />
                            {/* Icon inside the select (Pencil Icon) */}
                            <button
                              type="button"
                                className={`absolute right-2 top-2 text-gray-500 ${!line.product_id ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                title="Change product description"
                                onClick={() => handleEditDescription(index)}
                                
                                disabled={!line.product_id}  // Disable the button if no product is selected
                            >
                              <FaPen size={20} />
                            </button>
                          </div>
                          {/* price*/}
                          <input
                            name="unit_price"
                            value={line.unit_price}
                            onChange={(e) => handleTransactionLineChange(index, e)}
                            className="col-span-1 text-center text-gray-600 px-3 py-2 border rounded-md"
                          />
                          {/* Quantity Input */}
                          <div className="col-span-1 flex items-center relative">
                            <input
                              name="quantity"
                              value={line.quantity}
                              onChange={(e) => handleTransactionLineChange(index, e)}
                              ref={(el) => (quantityRefs.current[index] = el)}
                              className="text-center text-gray-600 px-3 py-2 border rounded-md focus:ring focus:ring-blue-300 w-1/2"
                              placeholder="Enter quantity"
                            />
                                                          
                            {/* Unit of Measure Label */}
                            {line.product_id && formattedProduct && (
                              <span
                                className="ml-1 text-gray-500 text-sm whitespace-nowrap"
                                title={formattedProduct.find(product => product.value === line.product_id)?.unit_of_measure || ''}
                              >
                                {formattedProduct
                                  .find(product => product.value === line.product_id)
                                  ?.unit_of_measure?.slice(0, 4) || ''}
                              </span>
                            )}
                                                          
                            {/* Calculator Button */}
                            <button
                              type="button"
                              className={`absolute ml-2 right-2 text-gray-500 bg-gray-100 hover:bg-gray-200 rounded-md focus:outline-none ${
                                !line.product_id ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                              }`}
                              title="Calculate quantity"
                              onClick={() => handleOpenCalculator(index)}
                              disabled={!line.product_id}
                            >
                              <FaCalculator size={20} />
                            </button>
                          </div>                  
                          <input
                            name="discount_percentage"
                            value={line.discount_percentage}
                            onChange={(e) => handleTransactionLineChange(index, e)}
                            className="col-span-1 text-center text-gray-600 px-3 py-2 border rounded-md"
                          />
                          <div className="col-span-1 text-right text-gray-600">{formatTwoDecimal(line.total)}</div>
                        </div>
                      ))
                        ) : (
                          <div className="text-center text-gray-500">No order detail found</div>
                      )}
                    </div>

                    <div className="p-4 bg-gray-50 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                        {order.transactionLines.length  > 0 && (
                            <div className="">
                                <p className="text-lg text-center font-bold mb-2">ORDER SUMMARY</p>
                                <div className="flex justify-between text-sm">
                                    <span>Subtotal:</span>
                                    <span className='font-bold'>{orderSummary.totalPriceExclusive}</span>
                                </div>
                                <div className="flex justify-between text-sm">
                                    <span>Discount:</span>
                                    <span>{orderSummary.totalDiscountExclusive}</span>
                                </div>
                             
                          
                    
                                <div className="flex justify-between text-sm">
                                    <span>Less Discount::</span>
                                    <span className='font-bold'>{orderSummary.totalDiscountedPriceExclusive}</span>
                                </div>
                    
                                <div className="flex justify-between text-sm">
                                    <span>Tax:</span>
                                    <span>{orderSummary.totalTaxAfterDiscounted }</span>
                                </div>
                    
                                <div className="flex justify-between text-sm">
                                    <span>Grand Total:</span>
                                    <span className='font-bold'>{formatCurrency(orderSummary.totalDiscountedPriceInclusive)}</span>
                                </div>        
                            </div> 
                        )}
                    </div>  
                   
      


            {/* Action Buttons */}
            <div className="flex justify-end space-x-4 mt-4">
                <button
                    onClick={handleSubmit}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                    <BsFillSendFill size={20} />
                    <span>Submit</span>
                </button>

                <button
                    onClick={handleClose}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                    <MdOutlineCancel size={20} />
                    <span>Close</span>
                </button>
            </div>    
        </div>
    )}
</div>
<Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} minWidth="90%">
     

            { isDescriptionModalOpen  && (
               <DescriptionModal
              
              // isOpen={isDescriptionModalOpen} // Control modal visibility
          
              onClose={() => setIsDescriptionModalOpen(false)}
              description={productDescription || ''} // Pass current description to modal
              product_name={productName || ''} // Pass product name to modal
              onSave={handleSaveNewDescription} // Pass the save handler to the modal
             // setDescription={setProductDescription} // You can use this if you need to manually update it
            />
            )}
            { isCalculatorOpen && (
              <CalculatorModal 
              isOpen={isCalculatorOpen} 
              onClose={() => setIsCalculatorOpen(false)} 
              onSave={handleSaveCalculatedQuantity} 
              defaultQuantity={quotation.transactionLines[selectedLineIndex]?.quantity}
            />
            )}
          </Modal>
</Layout>
);
};

export default EditOrder;
